<template>
  <div id="app">
    <div class="main">
      <!-- <transition name="slide-fade"> -->
        <keep-alive>
          <router-view v-if="isRouterAlive" :key='$route.fullPath'></router-view>
        </keep-alive>
      <!-- </transition> -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  watch: {
    $route:{
      handler(){
		// 初始化操作
      },
      immediate: true,
      deep: true,
    }
  },

  mounted() {
    // this.bodyScale();
    window.onresize = () => {
      return (() => {
        // this.bodyScale();
      })();
    };
  },

  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    bodyScale() {
      if (this.isMobile()) {
        let devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
        let scale = devicewidth / 1200; // 分母——设计稿的尺寸
        document.body.style.zoom = scale; //放大缩小相应倍数
      }
    },
    isMobile() {
      const regex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      return regex.test(navigator.userAgent) || window.innerWidth < 900;
    }
  }
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
  font: 400 1em / 1.8 PingFang SC, Lantinghei SC, Microsoft Yahei, Hiragino Sans GB, Microsoft Sans Serif, WenQuanYi Micro Hei, sans;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.slide-fade {
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
}
.slide-fade-enter,
.slide-fade-leave-to {
  left: 0;
  top: 0;
  right: 0;
  position: absolute;
  transform: translateY(100%);
}
.slide-fade-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s ease;
  transform: translateY(-100%);
  z-index: 100;
}
.special_search .el-input__inner:focus {
  border-width: 3px;
}
</style>
